import React, {useContext} from 'react';
import styles from './titleSectionSubPage.module.css'
import cn from "classnames";
import Image from 'next/image'
import {ModalContext} from "../modalLayout/ModalLayout";
import {TitleSectionSubPageProps} from "../../utils/PropsTypes";
import {useRouter} from "next/router";
import {en} from "../../locales/en";
import {ru} from "../../locales/ru";

const TitleSectionSubPage:React.FC<TitleSectionSubPageProps> = (
    {
        firstSection,
        title,
        description,
        boldDescription,
        backgroundUrl,
        mobileBackgroundUrl,
    }) => {
    const router = useRouter();
    const t:any = router.locale === 'en' ? en : ru;

    const modal = useContext(ModalContext)

    return (
        <div className={'bg-gray'}>

            <div className={styles.titleSectionImageContainer}>
                <Image layout={'responsive'} height={133} width={375} src={mobileBackgroundUrl} alt={'background'} />
            </div>

            <section
                className={cn(styles.titleSectionContainer, 'section')}
                style={{
                    backgroundImage: `url(${backgroundUrl.src})`
                }}
                ref={firstSection}
            >
                <div className={styles.textAboutTitleSection}>
                    <h1 className={styles.title}>{title}</h1>
                    {boldDescription && <p className={styles.titleDescriptionBold}>
                        {boldDescription}
                    </p>}
                    <p className={styles.titleDescription}>
                        {description}
                    </p>

                    <button className={'button_base'} onClick={modal.openFormModal}>
                        {t.btn.getConsultation}
                    </button>

                </div>
            </section>
        </div>
    );
};

export default TitleSectionSubPage;